/**
 * Caracteres con significado en HTML y la entidad por la que se sustituyen.
 */
const HtmlEntities: Record<string, string> =
{
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;"
};

/**
 * Codifica un texto para insertarlo en una plantilla HTML (contenido o valor de atributo entre comillas), de modo que
 * se muestre tal cual y nunca se interprete como etiquetas. Se usa con los datos de los intervinientes (nombre, DNI...)
 * que se meten en las plantillas de los contratos: en planes con varios titulares lo que escribe uno lo ve otro en su
 * sesión (auditoría de seguridad WEB-09). Devuelve "" con null/undefined.
 */
export function escapeHtml(text?: string | null): string
{
    if(text === undefined || text === null)
    {
        return "";
    }

    return String(text).replace(/[&<>"']/g, (character) => HtmlEntities[character]);
}
